export default __webpack_public_path__ + "static/media/LinkedInIcon.2a2ac1e2.svg";